// 🔒 AUTH-GUARDS-2026-05 — Single source of truth para post-login routing.
// Devuelve la primera ruta a la que un usuario debe aterrizar según sus permisos.
// Usada tanto por <RoleGate> (fallback) como por Login.js (navigate inicial)
// para evitar flicker /tables → /kitchen al iniciar sesión como cocina.

// 🔒 LANDING-INVENTORY-2026-08-10 — Misma lista de permisos que el RoleGate
// de /inventory-manager en App.js. Si cambia allá, cambiar acá también.
const INVENTORY_PERMS = ['manage_inventory','manage_purchase_orders','receive_purchase_orders','manage_suppliers','manage_ingredients','manage_warehouses','manage_recipes','manage_subrecipes','check_stock','view_inventory_valuation','view_inventory_audit','manage_stock_counts','manage_events','events_close','events_send_more'];  // 🔒 EVENTOS-PANTALLAS-2026-11-03

export function firstAllowedRoute(user) {
  if (!user) return '/login';
  const isAdmin = user.role === 'admin' || (user.role_level || 0) >= 100 || user.is_super_admin === true;
  if (isAdmin) return '/dashboard';
  const p = user.permissions || {};
  // Priority: tables (operativo) → kitchen (KDS) → reports → cash-register → inventory → dashboard
  if (p.open_table || p.access_all_tables) return '/tables';
  if (p.send_kitchen || p.receive_orders) return '/kitchen';
  if (p.view_reports) return '/reports';
  if (p.access_caja) return '/cash-register';
  // 🔒 LANDING-INVENTORY-2026-08-10 — Puestos puros de inventario/compras
  // (ej. GESTION COMPRAS) no tenían dónde aterrizar y caían en un loop
  // de redirección contra /dashboard sin view_dashboard.
  if (INVENTORY_PERMS.some(perm => p[perm])) return '/inventory-manager';
  if (p.view_dashboard) return '/dashboard';
  return '/dashboard';
}

// Same logic but using a hasPermission() callback (used by RoleGate inside App.js).
export function firstAllowedRouteBy(hasPermission, isAdmin) {
  if (isAdmin) return '/dashboard';
  if (hasPermission('open_table') || hasPermission('access_all_tables')) return '/tables';
  if (hasPermission('send_kitchen') || hasPermission('receive_orders')) return '/kitchen';
  if (hasPermission('view_reports')) return '/reports';
  if (hasPermission('access_caja')) return '/cash-register';
  // 🔒 LANDING-INVENTORY-2026-08-10
  if (INVENTORY_PERMS.some(perm => hasPermission(perm))) return '/inventory-manager';
  if (hasPermission('view_dashboard')) return '/dashboard';
  return '/dashboard';
}
